import dayjs from 'dayjs';
import { MatrialFilterFormValues, MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form/types';
import { SupplierTable } from 'features/master/components/table/supplier-table';
import { SupplierTopBar } from 'features/master/components/top-bar/supplier-top-bar';
import { useGetSuppliersList } from 'features/master/use-cases/get-getSuppliers';
import { usePaginationParams } from 'hooks';
import { omit } from 'lodash';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { formatDate } from 'utils/date';
const getInitialFilterValues: MatrialFilterFormValues = {
  date: [undefined, undefined],
  Title: undefined,
  phone_number: undefined,
  email: undefined,
  role: undefined,
  Type:undefined
};

const preparePayload = (params: MatrialFilterFormValuesPaginated) => {
  const createdAtFrom = params.date?.[0];
  const createdAtTo = params.date?.[1];

  return {
    ...omit(params, ['date']),    
    created_at_from: createdAtFrom
      ? formatDate({
        date: dayjs(createdAtFrom).startOf('day'),
        format: 'dbDate',
      })
      : undefined,
    created_at_to: createdAtTo
      ? formatDate({
        date: dayjs(createdAtTo).endOf('day'),
        format: 'dbDate',
      })
      : undefined,
  };
};

export const SupplierView = () => {
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState<number>(0);


  const { params, updateParams, resetPage } =
    usePaginationParams<MatrialFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });

  const getsupplierListQueryResponse: any = useGetSuppliersList(preparePayload(params), {
    retry: false,
  });

  const handleFiltersChange = (values: MatrialFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <SupplierTopBar
        getInitialFilterValues={getInitialFilterValues}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getsupplierListQueryResponse.refetch}
        addOrEdit={addOrEdit}
        setAddOrEdit={setAddOrEdit}
         setUserEditData={setUserEditData}
      />
      <SupplierTable
        ismasterListLoading={
          getsupplierListQueryResponse.isFetching
        }
        masterList={getsupplierListQueryResponse?.data?.rc}
        itemsCount={getsupplierListQueryResponse.data?.totalRecords || 0}
        tableParams={params}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getsupplierListQueryResponse.refetch}
        isFetching={ getsupplierListQueryResponse.isFetching}
        
      />
      <Outlet />
    </>
  );
};
